export enum ProductType {
  RETURN_TYPE = "return",
  PACKAGE_PROTECTION_TYPE = "package_protection",
  BOTH_TYPE = "return,package_protection",
  EXTENDED_WARRANTY_TYPE = "extended_warranty",
}
